import React, { useEffect } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';

import * as Api from '../../../weborder/Api';
import { Sorted } from '../../../weborder/Data';

interface Props {
  Close: () => any;
  handleNumber: (e: any) => any;
  handleSubmit: () => any;
  number: string;
  PickupLocationOptions: Api.PickupLocationOption[];
  PlaceOrderAfterTableSelect: boolean;
  prid: number;
  ShowModal: boolean;
  TableServiceCategory: Api.TableServiceCategory;
  translate: any;
}

export function TableSelectModal(props: Props): JSX.Element {
  const {
    Close: handleClose,
    handleNumber,
    handleSubmit,
    number,
    PickupLocationOptions: pickupLocationOptions,
    PlaceOrderAfterTableSelect: placeOrderAfterTableSelect,
    prid: prid,
    ShowModal: showModal,
    TableServiceCategory: tableServiceCategory,
    translate,
  } = props;

  useEffect(() => {
    if (
      showModal &&
      !number &&
      pickupLocationOptions &&
      pickupLocationOptions.length > 0
    ) {
      const firstRealOptionIndex = pickupLocationOptions.findIndex(
        (pickupLocationOption) => !pickupLocationOption.Value.startsWith('---'),
      );

      if (firstRealOptionIndex != -1) {
        handleNumber({
          target: {
            value: pickupLocationOptions[
              firstRealOptionIndex
            ].PickupLocationOptionId.toString(),
          },
        });
      }
    }
  }, [number, pickupLocationOptions, showModal]);

  return (
    <Dialog onClose={handleClose} open={showModal}>
      <DialogTitle>
        <Typography>
          {translate(`Enter_table_number_${tableServiceCategory}`)}
        </Typography>
      </DialogTitle>

      <DialogContent className="email-modal">
        {pickupLocationOptions && pickupLocationOptions.length > 0 ? (
          <select
            autoFocus={true}
            key="payment-dropdown"
            onChange={handleNumber}
            value={number}
          >
            {Sorted(pickupLocationOptions).map((pickupLocationOption) => (
              <option
                disabled={pickupLocationOption.Value.startsWith('---')}
                key={pickupLocationOption.DisplayOrder}
                value={pickupLocationOption.PickupLocationOptionId.toString()}
              >
                {pickupLocationOption.Value}
              </option>
            ))}
          </select>
        ) : (
          <input
            autoFocus={true}
            onChange={handleNumber}
            pattern="[0-9]*"
            placeholder={translate(`Table_number_${tableServiceCategory}`)}
            value={typeof number === 'number' ? number : ''}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button
          disabled={typeof number !== 'number'}
          key="table-select-button"
          onClick={placeOrderAfterTableSelect ? handleSubmit : handleClose}
        >
          <Typography>
            {prid == 3940 || prid == 3939
              ? translate('Confirm')
              : placeOrderAfterTableSelect
              ? translate('Place_order')
              : translate(`Select_table_${tableServiceCategory}`)}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
